// extracted by mini-css-extract-plugin
export default {"label":"ItemCard_label__N6j6s","picture":"ItemCard_picture__XWo9S","desc":"ItemCard_desc__tW0vS","p":"ItemCard_p__ZmmVh","b":"ItemCard_b__OHNYu","card":"ItemCard_card__UNSbd"};